import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from '../components/datepicker/custom-date-adapter';
import { Platform } from '@angular/cdk/platform';

export const customDateAdapterProvider = {
  provide: DateAdapter,
  useClass: CustomDateAdapter,
  deps: [MAT_DATE_LOCALE, Platform]
};
